import { useEffect, useState } from 'react';
import { getTaxpayerInformationSummaryPromise } from '../../get_taxpayer_information';

export const GetTaxpayerInformation = (organizationId: string) => {
    const [documentRequestStatus, setDocumentRequestStatus] = useState('none');

    useEffect(() => {
        getTaxpayerInformationSummaryPromise(organizationId)
            .then((drStatus: any) => {
                setDocumentRequestStatus(drStatus);
            })
            .catch((drStatus) => {
                setDocumentRequestStatus(drStatus);
            });
    }, [organizationId]);

    return documentRequestStatus;
};
